import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormSecurableDirective } from './formSecurable.directive';
import { EvoSecurableDirective } from './evosecurable.directive';
import { SecurableFormInputComponent } from './components/securable-form-component/securable-form-input-component';
import { SecurableLockComponent } from './components/securable-lock/securable-lock-component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EvoAntiSecurableDirective } from './evoAntiSecurable.directive';

@NgModule({
	imports: [
		FormsModule,
		ReactiveFormsModule,
		CommonModule,
		NgbModule,
	],
	declarations: [
		FormSecurableDirective,
		EvoSecurableDirective,
		EvoAntiSecurableDirective,
		SecurableFormInputComponent,
		SecurableLockComponent
	],
	exports: [FormSecurableDirective,
		EvoSecurableDirective,
		EvoAntiSecurableDirective,
		SecurableFormInputComponent,
		SecurableLockComponent,
	]
})
export class SecurableModule { }

